import script from "./TempResidenceDecl.vue?vue&type=script&setup=true&lang=js"
export * from "./TempResidenceDecl.vue?vue&type=script&setup=true&lang=js"

import "./TempResidenceDecl.vue?vue&type=style&index=0&id=1ef0dc66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef0dc66"]])

export default __exports__